// @flow
import React from 'react'
import {handleAnimationEnd} from './animation-lifecycle-utilities'
import audioManager from '../../../_audio/audio-manager.js'

class AnimationFillHp extends React.Component {

  props: {
  };

  async runAnimationSeries() {

    //Play SFX
    audioManager.playSfx("sfx_fillHp");

    //Move on to next step
    handleAnimationEnd();
  }

  componentDidMount() {
    this.runAnimationSeries();
  }

  render() {
    return null
  }
}

export default AnimationFillHp;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/AnimationFillHp.js